import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { hasAuthToken } from "../utils/authToken";

/**
 * Protects admin routes. Requires a logged-in user with role ADMIN.
 * Redirects to /home if not logged in or not an admin.
 */
const AdminRouter: React.FC = () => {
    const { user } = useAuth();
    const isAdmin =
        user &&
        !user.guest &&
        hasAuthToken() &&
        user.role === "ADMIN";

    return isAdmin ? (
        <Outlet />
    ) : (
        <Navigate to="/home" replace />
    );
};

export default AdminRouter;
